import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { getAppSettings } from '@/utils';
import { PlayerTypeV2Enum } from '@/enum/player-v2/PlayerTypeV2Enum';
// import { Typography } from '@material-ui/core';
// import { Typography } from '@material-ui/core';

// export interface AdDialogProps {
//   adDialogCallback: () => void;
// }

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export interface AdDialogProps {
  setCashierDialogAction: (data: any) => void;
}

export interface ExternalProps {
  user: any;
}

export const convertPSTToUnix = (dateString: string): number => {
  try {
    const date = new Date(new Date(dateString).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));

    // Obtener el UNIX timestamp en milisegundos
    return date.getTime();
  } catch (error) {
    console.error('Error al convertir la fecha:', error);
    return 0;
  }
};

export default function AdDialog(props: AdDialogProps & ExternalProps) {
  const imagesCdn = getAppSettings().imagesCdn;
  const { setCashierDialogAction, user } = props;

  const [open, setOpen] = React.useState(false);
  const [img, setImg] = React.useState('');

  useEffect(() => {
    if (user) {
      showPopup();
    }
  }, [user]);

  const showPopup = () => {
    const lastPopUpStorage: string | null = localStorage.getItem('lastPopUp2');

    const lastPopUp = lastPopUpStorage ? JSON.parse(lastPopUpStorage) : { day: null, cont: null };

    if (lastPopUp == null || lastPopUp.day == null || lastPopUp.cont == null || lastPopUp.day !== new Date().getDate().toString()) {
      localStorage.setItem('lastPopUp2', JSON.stringify({ day: new Date().getDate().toString(), cont: 1 }));
    } else {
      return;
    }

    const keepShowingAd = localStorage.getItem('keepShowingAdRaf');

    let showPopup = false;

    try {
      if (
        user &&
        user.player_type &&
        user.player_type.id &&
        user.player_type.id == PlayerTypeV2Enum.POSTUP &&
        (keepShowingAd == 'true' || keepShowingAd == null)
      ) {
        // SHARP AGENTS
        if (user.dgs_agent && user.dgs_agent.id && ![204, 214, 425].includes(user.dgs_agent.id ?? -1)) {
          const currentTime = Date.now();

          const banners = [
            // {
            //   startDate: '2025-02-20 14:10',
            //   endDate: '2025-02-20 17:00',
            //   img: 'marketing/marketing_postup_2_20_2025.jpg',
            // },
            {
              startDate: '2025-02-21 08:00',
              endDate: '2025-02-21 21:00',
              img: 'marketing/marketing_postup_2_21_2025.jpg',
            },
            {
              startDate: '2025-02-22 08:00',
              endDate: '2025-02-22 17:00',
              img: 'marketing/marketing_postup_2_22_2025.jpg',
            },
            {
              startDate: '2025-02-23 08:00',
              endDate: '2025-02-23 20:00',
              img: 'marketing/marketing_postup_2_23_2025.jpg',
            },
          ];

          try {
            banners.forEach(banner => {
              const startDate = convertPSTToUnix(banner.startDate);
              const endDate = convertPSTToUnix(banner.endDate);

              if (startDate > 0 && endDate > 0 && currentTime >= startDate && currentTime <= endDate) {
                setImg(imagesCdn + banner.img);
                showPopup = true;
                setTimeout(() => setOpen(showPopup), 2000);
                return;
              }
            });
          } catch (error) {
            console.log(error);
          }

          // change this to show/hide the popup
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  //   const dontShowAnymore = () => {
  //     localStorage.setItem('keepShowingAdRaf', 'false');
  //     setOpen(false);
  //   };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        {/* Game Ad */}
        {/* <DialogContent>
          <img
            src={}
            style={{ width: '100%', height: 'auto', maxHeight: '600px' }}
            onClick={() => {
              getHistory().push('/cashier');
              handleClose();
            }}
          />
        </DialogContent> */}

        {/* Maintenance */}
        {/* <DialogTitle id='alert-dialog-slide-title'>{'VIPClub'}</DialogTitle>
        <DialogContent style={{ textAlign: 'center' }}>
          <Typography variant='h5'>
            Live Betting
            <br />
            Scheduled Maintenance
          </Typography>
          <Typography variant='h6'>04/25/2022 from 21:00 hours to 23:00 hours PST.</Typography>
        </DialogContent> */}

        {/* RAF AD */}

        <DialogTitle id='alert-dialog-slide-title'>{'VIPClub'}</DialogTitle>
        <DialogContent>
          <img
            src={img}
            style={{ width: '100%', height: 'auto', maxHeight: '600px', maxWidth: '400px' }}
            onClick={() => {
              setCashierDialogAction({ isShow: true, type: 'cashier' });
              handleClose();
            }}
          />
        </DialogContent>

        {/* Live Betting Down */}
        {/* <DialogTitle id='alert-dialog-slide-title'>Live Betting</DialogTitle>
        <DialogContent>
          <Typography variant='h5'>Attention</Typography>
          <Typography variant='h6'>
            Live betting platform will be down for maintenance today from 23:00PDT to 01:00PDT, we appreciate your understanding in this
            matter.
            <br />
            Thank you.
          </Typography>
        </DialogContent> */}

        {/* MM AD */}
        {/* <DialogTitle id='alert-dialog-slide-title'>{'VIPClub'}</DialogTitle>
        <DialogContent>
          <img
            src={`${process.env.PUBLIC_URL}`}
            style={{ width: '100%', height: 'auto', maxHeight: '600px' }}
            onClick={() => {
              getHistory().push('/bracket');
              handleClose();
            }}
          />
        </DialogContent> 

        {/* Announcement */}
        {/* <DialogTitle id='alert-dialog-slide-title'>{'Valued Client,'}</DialogTitle>
        <DialogContent>
          <Typography style={{ textAlign: 'center' }}>
            Please make note of the Fee schedule for Deposits and Withdrawals. Operationally, we have not charged for Deposits since we
            opened. But the Fees for Credit Card Processing and Trading every Deposit into Bitcoin on behalf of the client is very
            expensive.
            <br />
            <br />
            Therefore, effective immediately we must begin charging a deposit fee for each transaction. Bitcoin Deposits will remain “No
            Fee” or 0%. But the others must be increased to help minimize the cost.
            <br />
            <br /> On a POSITIVE NOTE, we have REDUCED the Instant Pay Withdrawal Fee from 10% to 5%! This allows each Valued Client to
            receive their WITHDRAWALS IN SECONDS and at a reduced fee going forward. Thank you for your business and understanding!
            <br />
            <br />
            Respectfully,
            <br />
            VIP Club Management
          </Typography>
        </DialogContent> */}

        <DialogActions style={{ justifyContent: 'center' }}>
          {/* <Button onClick={dontShowAnymore} color='default' variant='outlined'>
            Don&apos;t Show Again
          </Button> */}
          <Button onClick={handleClose} color='secondary' variant='contained'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
